import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";

import { AuthProvider } from "./contexts/AuthContext";

import ProtectedRoute from "./components/ProtectedRoute";
import AccountLayout from "./components/layout/AccountLayout";
import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import Products from "./pages/admin/ProductsNew";
import Orders from "./pages/admin/Orders";
import OrderView from "./pages/admin/OrderView";
import EditProduct from "./pages/admin/EditProduct";
import CouponsPage from "./pages/CouponsPage";
import PartnershipsManager from "./pages/admin/PartnershipsManager";
import PartnerOrders from "./pages/admin/PartnerOrders";
import ChangePassword from "./pages/admin/ChangePassword";

import { BASE_FOLDER } from "./config";
import CreateProduct from "./pages/admin/CreateProduct";
import RoleBasedRedirect from "./components/RoleBasedRedirect";
import ThemeFiles from "./pages/admin/ThemeFiles";

function App() {
  return (
    <AuthProvider>
      <div
        id="kt_docs_toast_stack_container"
        className="toast-container position-fixed bottom-0 end-0 p-3 z-index-9999"
      ></div>
      <BrowserRouter basename={"/" + BASE_FOLDER}>
        <Routes>
          {/* Public Routes */}
          {/* <Route path="/ai" element={<WebsiteAi />} /> */}
          <Route path="/account/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <RoleBasedRedirect />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <AccountLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<RoleBasedRedirect />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="products" element={<Products />} />
            <Route path="coupons" element={<CouponsPage />} />
            <Route path="products/create" element={<CreateProduct />} />
            <Route
              path="/account/products/:id/edit"
              element={<EditProduct />}
            />
            <Route path="orders" element={<Orders />} />
            <Route path="orders/:id" element={<OrderView />} />
            <Route path="change-password" element={<ChangePassword />} />
            {/* Add more admin routes here as needed */}
          </Route>
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AccountLayout />
              </ProtectedRoute>
            }
          >
            <Route path="partnerships" element={<PartnershipsManager />} />
            <Route path="theme-files" element={<ThemeFiles />} />
          </Route>
          <Route
            path="/partner"
            element={
              <ProtectedRoute>
                <AccountLayout />
              </ProtectedRoute>
            }
          >
            <Route path="orders" element={<PartnerOrders />} />
            <Route path="change-password" element={<ChangePassword />} />
          </Route>
          <Route path="*" element={<RoleBasedRedirect />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
